import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import { handleTableChange } from "../../../../utils";
import {
    getAssetLocationHistoryList,
} from "../../../../redux/assetlocationhistory/assetLocationHistoryState";
import ColumnSearchFilter from "components/search/ColumnSearchFilter";
import HeaderComponent from "components/card/HeaderComponent";
import { MapPinned } from "lucide-react";

const AssetLocationHistoryTable = ({ recordId }) => {
	const dispatch = useDispatch();
	const recordList = useSelector((state) => state.assetLocationHistory.assetLocationHistoryList?.items);
	const pagination = useSelector((state) => state.assetLocationHistory.assetLocationHistoryList?.pagination);
	const filters = useSelector((state) => state.assetLocationHistory.assetLocationHistoryList?.filters);

	const doSearch = useCallback(
	(filters) => dispatch(getAssetLocationHistoryList(filters)),
	[dispatch]
);

	const { getDateRangeColumnFilter } = ColumnSearchFilter();

	const columns = [
		{
			title: "Date",
			dataIndex: "alh_move_date",
			key: "alh_move_date",
			width: "15%",
			...getDateRangeColumnFilter("alh_move_date"),
		},
		{
			title: "Location",
			dataIndex: "location_name",
			key: "location_name",
			width: "20%",
			render: (value) => value || "-",
		},
		{
			title: "Status",
			dataIndex: "action_name",
			key: "action_name",
			width: "15%",
		},
		{
			title: "Assigned To",
			dataIndex: "assigned_to_name",
			key: "assigned_to_name",
			width: "20%",
			render: (value) => value || "-",
		},
		{
			title: "Updated By",
			dataIndex: "updated_by_name",
			key: "updated_by_name",
			width: "10%",
			render: (value) => value || "-",
		},
	];

	useEffect(() => {
		doSearch({
			alh_asset_id: recordId,
			paginate: pagination.per_page,
		});
	}, [recordId, doSearch, pagination.per_page]);

	return (
		<HeaderComponent
			title="Location History"
			titleClass="font-semibold"
			labelIcon={<MapPinned className="w-6 h-6"/>}
			bgcolor="bg-green-50 dark:bg-green-900/30"
		>			
			<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
				<Table
					dataSource={recordList}
					columns={columns}
					rowKey={(record) => record.alh_id}
					pagination={{
						...pagination,
						showTotal: (total, range) =>
							`${range[0]} - ${range[1]} of ${total} records`,
					}}
					onChange={handleTableChange(doSearch, filters)}
				/>
			</div>
		</HeaderComponent>
	);
};

export default (AssetLocationHistoryTable);